module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-hail-0f23aa5a.svg";